import PassengerAddParams from "../../../../../../common/services/passenger/add/passenger-add-params";
import passengerAddFactory from "../../common/passenger-add.factory";
import PassengerAddByCargoFormData from "./types/passenger-add-by-cargo-form-data";

const createAddPassengerParams = (
  formData: PassengerAddByCargoFormData,
): PassengerAddParams => {
  const addresses = passengerAddFactory.createAddPassengerRequestAddresses(
    formData.addresses,
  );
  const dispatchIds = passengerAddFactory.createAddPassengerRequestDispatchIds(
    formData.dispatches!,
  );

  const request: PassengerAddParams = {
    firstName: formData.firstName.trim(),
    lastName: formData.lastName.trim(),
    mobilePrimaryPrefix: formData.mobile.dialingCode || undefined,
    mobilePrimary: formData.mobile.number || undefined,
    mobileSecondaryPrefix: formData.alternativeMobile.dialingCode
      ? formData.alternativeMobile.dialingCode
      : undefined,
    mobileSecondary: formData.alternativeMobile.number
      ? formData.alternativeMobile.number
      : undefined,
    email: formData.email.trim(),
    username: formData.username.trim(),
    password: formData.password,
    passenger: {
      addresses: addresses,
      dispatchIds: dispatchIds,
    },
  };

  return request;
};

const passengerAddByCargoFactory = {
  createAddPassengerParams,
  createDispatchSelectOptions: passengerAddFactory.createDispatchSelectOptions,
};

export default passengerAddByCargoFactory;
